import React from 'react';

interface IProps {
  style?: any;
  stroke?: string;
}

const NotHiddenIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg" style={props.style}>
      <path d="M15 4.39394C15 4.81818 11.8663 7.78788 8 7.78788C4.13409 7.78788 1 4.81818 1 4.39394C1 3.9697 4.13409 1 8 1C11.8663 1 15 3.9697 15 4.39394Z" stroke={props.stroke??"#122442"} strokeMiterlimit="10"/>
      <path d="M8.00012 6.51586C6.83048 6.51586 5.87891 5.56407 5.87891 4.39465C5.87891 3.22501 6.83048 2.27344 8.00012 2.27344C9.17018 2.27344 10.1213 3.22501 10.1213 4.39465C10.1213 5.56407 9.17018 6.51586 8.00012 6.51586Z" stroke={props.stroke??"#122442"} strokeMiterlimit="10"/>
    </svg>
  )
}

export default NotHiddenIcon;